import { render, staticRenderFns } from "./NavBusinessProcess.vue?vue&type=template&id=8bd7d5a6&scoped=true"
import script from "./NavBusinessProcess.vue?vue&type=script&lang=js"
export * from "./NavBusinessProcess.vue?vue&type=script&lang=js"
import style0 from "./NavBusinessProcess.vue?vue&type=style&index=0&id=8bd7d5a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd7d5a6",
  null
  
)

export default component.exports